<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<div class="flex w-full flex-col">
  <ods-attachment-wrapper>
    @if (caption) {
      <ods-attachment fileType="json" [caption]="caption" [downloadAllowed]="false">
        @if (deleteLabel) {
          <ods-button
            close
            class="self-center"
            [attr.data-test-id]="dataTestId + '-delete-file-button'"
            (clicked)="deleteFile()"
            [text]="deleteLabel"
            [destructive]="true"
          />
        } @else {
          <ods-button
            close
            class="self-center"
            [attr.data-test-id]="dataTestId + '-delete-file-button'"
            (clicked)="deleteFile()"
            size="fit"
            variant="ghost"
            icon="delete"
            [ariaLabel]="deleteIconLabel"
            [destructive]="true"
          />
        }
      </ods-attachment>
    }
  </ods-attachment-wrapper>

  @if (!caption) {
    <ods-file-upload-button
      class="w-fit"
      variant="label-outline"
      [id]="effectiveButtonId"
      [isLoading]="loading"
      [dataTestId]="dataTestId + '-file-upload-button'"
      [accept]="accept"
      [isRequired]="isRequired"
      icon="attach-file"
      [text]="label"
    />
  }

  <odc-validation-error
    [id]="validationErrorId"
    [invalidParams]="invalidParams"
    [label]="label"
    [attr.data-test-id]="dataTestId + '-file-upload-error'"
  />
</div>
